import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackDashboardEvent = createAnalyticsTracker('dashboardV2');
